import { Component } from '@angular/core';

@Component({
  selector: 'app-environmental-management',
  templateUrl: './environmental-management.component.html',
  styleUrl: './environmental-management.component.scss'
})
export class EnvironmentalManagementComponent {

}
